export default class TrackingService {
    getComboButtonWidgetPayload(comboId, source, status, comboType, comboIsCGI) {
        return {
            id: 'ft3bcn_cobu1',
            name: 'ComboButton',
            position: 1,
            status: status,
            labels: {
                promo_FeatureNumber: ["1"],
                promo_FilledSlots: ["1"],
                promo_Feature: ["true"],
                promo_Content: [comboId],
                promo_Source: [source],
                promo_ComboType: [comboType],
                promo_IsCgiCombo: [comboIsCGI === true ? "true" : "false"]
            }
        };
    }

    getComboButtonPayload(status, variationId) {
        return {
            id: 'ft3bcn_cobu1_tile1',
            parentId: 'ft3bcn_cobu1',
            name: 'ComboButton-Tile',
            position: 1,
            status: status,
            variationId: variationId,
            labels: {}
        };
    }

    sendPromoButtonClickTrackingEvent(comboId, comboSource, comboType, variationId, comboIsCGI) {
        const statusName = 'click';
        const status = 'clicked';
        const pageCluster = window.o_util.misc.getPagecluster();

        let oldEventPayload = {
            'wk.promo_AttributionFeature': `ComboButton_${pageCluster}`,
            'promo_ComboButton': `${comboId}∞1$1∞1∞1∞${comboSource}∞${statusName}`,
            'wk.promo_Attribution': `promo_ComboButton∞${comboId}∞1$1∞1∞1∞${comboSource}∞${statusName}`,
            'product_VariationId': variationId,
            'promo_ComboType': comboType,
            'wk.promo_AttributionSource': comboSource
        }
        let newEventPayload = {
            name: statusName,
            features: [
                this.getComboButtonWidgetPayload(comboId, comboSource, status, comboType, comboIsCGI),
                this.getComboButtonPayload(status, variationId)
            ]
        }
        window.o_global.eventQBus.emit('tracking.bct.submitMoveAction', oldEventPayload, newEventPayload)
        window.o_global.eventQBus.emit('tracking.bct.trackOnNextPageImpression', {'promo_Click': 'ComboButton'});
    }

    sendPromoButtonPageImpressionTrackingEvent(comboId, comboSource, comboType, variationId, comboIsCGI) {
        let loadEventPayload = this.getLoadEventPayload(comboId, comboSource, comboType, variationId, comboIsCGI);

        window.o_global.eventQBus.emit('tracking.bct.addFeaturesToPageImpression', loadEventPayload)
    }

    sendPromoButtonMergePageImpression(comboId, comboSource, comboType, emid, variationId, comboIsCGI) {
        let payload = {
            name: 'change',
            features: this.getLoadEventPayload(comboId, comboSource, comboType, variationId, comboIsCGI)
        }

        window.o_global.eventQBus.emit('tracking.bct.addActionToEvent', payload, emid)
    }

    getLoadEventPayload(comboId, comboSource, comboType, variationId, comboIsCGI) {
        const status = 'loaded';
        let loadEventPayload = [
            this.getComboButtonWidgetPayload(comboId, comboSource, status, comboType, comboIsCGI),
            this.getComboButtonPayload(status, variationId)
        ];
        return loadEventPayload;
    }
}
